import ApiClient from './ApiClient.js';
import FinanceApi from './finance.js';

export default () => {
  const api = new ApiClient();

  return {
    apiClient: api,
    finance: new FinanceApi({apiClient: api})
  };
};
